import React, { useState, useEffect } from 'react';
import '../styles/MesTachesPage.css';
import MesTaches from './MesTaches';
import { useTaches } from '../hooks/useTaches';

const MesTachesPage = ({ userRole = 'directeur', userName = 'Utilisateur Test', navigationParams = {} }) => {
  const { stats, taches } = useTaches();
  
  // Calculer des statistiques avancées
  const calculerStatistiquesAvancees = () => {
    const maintenant = new Date();
    const debutSemaine = new Date(maintenant);
    debutSemaine.setDate(maintenant.getDate() - maintenant.getDay());
    
    const tachesCetteSemaine = taches.filter(tache => {
      const dateCreation = new Date(tache.dateCreation);
      return dateCreation >= debutSemaine;
    });
    
    // Calculer le temps moyen de completion
    const tachesTerminees = taches.filter(t => t.statut === 'termine');
    let tempsMoyenJours = 0;
    
    if (tachesTerminees.length > 0) {
      const totalJours = tachesTerminees.reduce((acc, tache) => {
        const dateCreation = new Date(tache.dateCreation);
        const dateEcheance = new Date(tache.echeance);
        const diffJours = Math.abs((dateEcheance - dateCreation) / (1000 * 60 * 60 * 24));
        return acc + diffJours;
      }, 0);
      tempsMoyenJours = (totalJours / tachesTerminees.length).toFixed(1);
    }
    
    return {
      tauxCompletion: stats.tauxCompletion,
      tempsMoyenJours,
      tachesCetteSemaine: tachesCetteSemaine.length
    };
  };

  const statsAvancees = calculerStatistiquesAvancees();

  return (
    <div className="mes-taches-page">
      <div className="page-header">
        <div className="breadcrumb">
          <span className="breadcrumb-item">Accueil</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-item active">Mes Tâches</span>
        </div>
        
        <div className="page-title-section">
          <div className="page-title">
            <i className="fas fa-clipboard-list"></i>
            <h1>Gestion de Mes Tâches</h1>
          </div>
          <p className="page-description">
            Organisez et suivez vos tâches personnelles pour une meilleure productivité
          </p>
        </div>
      </div>

      <div className="page-content">
        <div className="taches-container">
          <MesTaches userRole={userRole} userName={userName} navigationParams={navigationParams} />
        </div>
        
        <div className="sidebar-info">
          <div className="info-card">
            <h3>💡 Conseils d'utilisation</h3>
            <ul>
              <li>Organisez vos tâches par priorité et catégorie</li>
              <li>Définissez des échéances réalistes</li>
              <li>Marquez les tâches terminées pour suivre votre progression</li>
              <li>Utilisez les catégories pour grouper les tâches similaires</li>
              <li>Nettoyez régulièrement les tâches anciennes</li>
            </ul>
          </div>
          
          <div className="info-card">
            <h3>📊 Statistiques</h3>
            <div className="quick-stats">
              <div className="quick-stat">
                <span className="stat-label">Taux de completion</span>
                <span className="stat-value">{statsAvancees.tauxCompletion}%</span>
              </div>
              <div className="quick-stat">
                <span className="stat-label">Temps moyen</span>
                <span className="stat-value">{statsAvancees.tempsMoyenJours}j</span>
              </div>
              <div className="quick-stat">
                <span className="stat-label">Cette semaine</span>
                <span className="stat-value">{statsAvancees.tachesCetteSemaine} tâches</span>
              </div>
            </div>
          </div>

          {stats.en_retard > 0 && (
            <div className="info-card alert-card">
              <h3>⚠️ Attention</h3>
              <p>Vous avez <strong>{stats.en_retard} tâche(s) en retard</strong>. Pensez à les traiter en priorité !</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MesTachesPage;
